import React, { useState, useEffect } from 'react';
import { MSTRMobilePriceChart } from './MSTRMobilePriceChart';
import { Prediction } from '../../../types/predictions';
import { Theme } from '../../../theme';

interface MSTRMobileChartWrapperProps {
  predictions: Prediction[];
  activePredictions: number[];
  chartData: Array<{ time: string; value: number }>; // This is Bitcoin data, we'll ignore it
  isDarkMode: boolean;
  theme: Theme;
}

const MSTRMobileChartWrapper: React.FC<MSTRMobileChartWrapperProps> = ({
  predictions,
  activePredictions,
  chartData: ignoredBitcoinData, // Ignore Bitcoin data
  isDarkMode,
  theme
}) => {
  const [mstrChartData, setMstrChartData] = useState<Array<{ time: string; value: number }>>([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // Fetch MSTR-specific price data
  useEffect(() => {
    const fetchMSTRPrices = async () => {
      setIsLoading(true);
      try {
        const hostname = window.location.hostname;
        // REMOVED ALL LIMITS: Get all available MSTR price data
        const apiUrl = '/api/mstr/prices';
        
        
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        
        if (result.success && result.data) {
          // Transform MSTR price data to match Bitcoin format
          const transformedPrices = result.data
            .map((item: any) => ({
              time: item.date, // Keep as string - MobilePriceChart will parse it
              value: parseFloat(item.close)
            }))
            .filter((item: any) => item.value > 0) // Filter out invalid prices
            .sort((a: any, b: any) => new Date(a.time).getTime() - new Date(b.time).getTime()); // Sort chronologically
          
          setMstrChartData(transformedPrices);
        } else {
          setMstrChartData([]);
        }
      } catch (error) {
        console.error(`📈 MSTR Mobile: Error fetching MSTR prices:`, error);
        setMstrChartData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMSTRPrices();
  }, []);

  // Show loading state
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100%',
        width: '100%',
        color: theme.text,
        boxSizing: 'border-box'
      }}>
        Loading MSTR chart...
      </div>
    );
  }
  
  // REMOVED DATE FILTERING: Use all available MSTR data
  const processedData = mstrChartData.filter(point => point.value > 0);


  return (
    <div style={{ width: '100%', height: '100%', boxSizing: 'border-box' }}>
      <MSTRMobilePriceChart
        predictions={predictions}
        activePredictions={activePredictions}
        chartData={processedData} // Now uses MSTR price data
        isDarkMode={isDarkMode}
        theme={theme}
      />
    </div>
  );
};

export default MSTRMobileChartWrapper;